import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/authentication";

const { actions, types } = createActions({
  fetchUser: ["token", "onFailure"],
  requestLogin: ["data"],
  authorizeUser: ["token"],
  userFetchedSuccessfully: ["user", "role"],
  authenticationFailed: ["message"],
  clearErrors: [],
  signOut: [],
  setAuthenticateUser: ["authenticateUser"],
  setUser: ["user"],
  setSessionExpired: ["sessionExpired"],
  setSessionId: ["sessionId"],
  setLoadingFalse: [],
  setAuthenticationError: ["error"],
});

const reducer = createReducer(initialState, {
  [types.USER_FETCHED_SUCCESSFULLY]: (state, { payload }) => ({
    ...state,
    user: payload.user,
    authenticated: true,
    loadingUser: false,
    loading: false,
    authenticateUser: true,
    authenticationError: null,
    role: payload.role,
  }),
  [types.AUTHENTICATION_FAILED]: (state, { payload }) => ({
    ...state,
    authenticated: false,
    authenticationError: payload.message,
  }),
  [types.REQUEST_LOGIN]: (state) => ({
    ...state,
    authenticated: false,
    loading: true,
    authenticationError: null,
  }),
  [types.CLEAR_ERRORS]: (state) => ({
    ...state,
    authenticated: false,
    authenticationError: null,
  }),
  [types.SET_SESSION_ID]: (state, { payload }) => ({
    ...state,
    sessionId: payload,
  }),
  [types.SET_LOADING_FALSE]: (state) => ({
    ...state,
    loading: false,
  }),
  [types.SET_AUTHENTICATION_ERROR]: (state, { payload }) => ({
    ...state,
    authenticationError: payload.error,
  }),
  [types.SET_AUTHENTICATE_USER]: (state, { payload }) => ({
    ...state,
    authenticateUser: payload.authenticateUser,
  }),
  [types.SET_USER]: (state, { payload }) => ({
    ...state,
    user: payload.user,
  }),
  [types.SET_SESSION_EXPIRED]: (state, { payload }) => ({
    ...state,
    sessionExpired: payload.sessionExpired,
  }),
});

export { reducer as default, types, actions };
